import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { questionKey } from '../response/reducer';
import { t } from '../../../utils/translate';

export const PureTotal = ({ currentSum, sum }) => (
  <th
    className={classnames('fs-12 fw-n', {
      'c-aaa': currentSum < sum,
      'c-red': currentSum > sum,
    })}
  >
    <span className="constant_sum_so_far">{currentSum}</span>
    {` ${t('of')} `}
    <span>{sum}</span>
  </th>
);

PureTotal.propTypes = {
  currentSum: PropTypes.number,
  sum: PropTypes.number,
};

//

const mapStateToProps = (state, ownProps) => {
  const question = state[questionKey(ownProps)];
  return {
    currentSum: question.none ? 0 : question.currentSum,
  };
};

const Total = connect(mapStateToProps)(PureTotal);

export default Total;
